module.exports = __webpack_public_path__ + "img/project10_8.fd8cf32e.jpg";